import React from 'react';
import ScreenComponent from './ScreenComponent';
import { Confirmation } from '../Confirmation';
import axios from 'axios';
import { config } from '../../app/config';
import { connect } from "react-redux";
import { preloaderShow, preloaderHide, alert } from '../../actions';
import { NotesList } from "./note/NotesList";
import '../../styles/elements/screen.scss';
import '../../styles/screens/note.scss';
import TranslationService from "../../app/services/TranslationService";
import {Button} from "../icymat-design/Button";
import {Textarea} from "../icymat-design/Textarea";


class NoteClass extends ScreenComponent
{
    constructor(props)
    {
        super(props);

        this.state = {
            notes: [],
            note_id: '',
            content: '',
            delete_note: null
        };
    };

    getScreenName() {
        return 'note';
    };

    componentDidUpdate = (prevProps, prevState) => {
        if (prevProps.view !== this.getScreenName() && this.props.view === this.getScreenName()) {
            this.loadNotes();
        }
    };

    handleContentChange = (event) => {
        this.setState({content: event.target.value});
    };

    loadNotes = () => {
        this.props.preloaderShow();
        let that = this;

        axios.get(config.apiAddress + '/app/note/list')
            .then(function (response) {
                that.setState({notes: response.data});
                that.props.preloaderHide();
            }).catch(function(error) {
                that.props.alert(TranslationService.trans(that.props.language, 'note.actions.open_failed'));
            });
    };

    openNote = (noteId) => {
        let that = this;
        if (noteId !== null) {
            this.props.preloaderShow();

            axios.get(config.apiAddress + '/app/note/' + noteId)
                .then(function (response) {
                    that.setState({
                        note_id: noteId,
                        content: response.data.note
                    });
                    that.props.preloaderHide();
                }).catch(function(error) {
                that.setState({
                    note_id: '',
                    content: ''
                });
                that.props.preloaderHide();
                that.props.alert(TranslationService.trans(that.props.language, 'note.actions.open_failed'));
            });
        }
    };

    cancel = () => {
        this.setState({note_id: '', content: ''});
    };

    save = () => {
        let that = this;
        this.props.preloaderShow();

        if (this.state.note_id === '') {
            axios.post(config.apiAddress + '/app/note', {content: that.state.content})
                .then(function (response) {
                    that.cancel();
                    that.loadNotes();
                    that.props.alert(TranslationService.trans(that.props.language, 'note.actions.saved'));
                }).catch(function(error) {
                    that.props.alert(TranslationService.trans(that.props.language, 'note.actions.saved_failed'));
                    that.props.preloaderHide();
                });
        } else {
            axios.put(config.apiAddress + '/app/note/' + that.state.note_id, {content: that.state.content})
                .then(function (response) {
                    that.cancel();
                    that.loadNotes();
                    that.props.alert(TranslationService.trans(that.props.language, 'note.actions.saved'));
                }).catch(function(error) {
                    that.props.alert(TranslationService.trans(that.props.language, 'note.actions.saved_failed'));
                    that.props.preloaderHide();
                });
        }
    };

    deleteNote = () => {
        if (this.state.note_id === '') {
            return;
        }

        this.setState({delete_note: config.apiAddress + '/app/note/' + this.state.note_id});
    };

    deleteNoteSuccess = (response, address) => {
        this.cancel();
        this.loadNotes();
        this.props.alert(TranslationService.trans(this.props.language, 'note.actions.deleted'));
        this.setState({delete_note: null})
    };

    deleteNoteError = (error, address) => {
        this.props.alert(TranslationService.trans(this.props.language, 'note.actions.deleted_failed'));
    };

    render() {
        return (
            <div className="screen screen-note" style={this.getStyle()}>
                <div className="content imd-text-accent">
                    <div className="imd-container-fluid">
                        <div className="imd-row">
                            <div className="imd-col-lg-3 imd-col-md-4 imd-col-xs-12">
                                <NotesList
                                    className="imd-hide-sm imd-hide-xl"
                                    elements={this.state.notes}
                                    openedElementId={this.state.note_id}
                                    openElement={this.openNote}
                                    lang={this.props.lang}
                                />
                            </div>

                            <div className="imd-col-lg-9 imd-col-md-8 imd-col-xs-12">
                                <div className="actions">
                                    <Button
                                        text={TranslationService.trans(this.props.language, 'common.save')}
                                        color={'main'}
                                        onClick={() => this.save()}
                                    />

                                    <Button
                                        text={TranslationService.trans(this.props.language, 'common.cancel')}
                                        color={'accent'}
                                        secondary={true}
                                        onClick={this.cancel}
                                        display={this.state.note_id !== ''}
                                    />

                                    <Button
                                        text={TranslationService.trans(this.props.language, 'common.delete')}
                                        color={'red'}
                                        secondary={true}
                                        onClick={this.deleteNote}
                                        display={this.state.note_id !== ''}
                                    />
                                </div>

                                <hr className="imd-border-color-140-accent" />

                                <Textarea
                                    height={'50vh'}
                                    value={this.state.content}
                                    placeholder={TranslationService.trans(this.props.language, 'common.content')}
                                    onChange={this.handleContentChange}
                                />
                            </div>
                        </div>
                    </div>

                    <Confirmation
                        address={this.state.delete_note}
                        onSuccess={this.deleteNoteSuccess}
                        onError={this.deleteNoteError}
                        onCancel={() => this.setState({delete_note: null})}
                    />
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        email: state.login.email,
        device: state.login.device,
        view: state.view,
        language: TranslationService.getLanguage(state.user)
    }
};

export const NoteScreen = connect(mapStateToProps, {preloaderShow, preloaderHide, alert})(NoteClass);
